<template>
    <div class="Show">
        <van-nav-bar :title="title" />
        <div class="cmain">
            <div v-for="(item, index) in items" :key="index" class="card_row rowflex">
                <i :class="{'iconfont':true,'icon-xuanze':true, 'active':selections.filter(x => x.commodityId === item.commodityId).length>0}" 
                    @click="changeSelectState(item)" v-if="!isDirectOrder"></i>
                <div class="card_item">
                    <div class="card_left"><img :src="item.commodity.imageUrl" /></div>
                    <div class="card_right">
                        <div class="card_title">{{ item.commodity.name }}</div>
                        <div class="card_desc">{{ item.commodity.weight ? item.commodity.weight + "kg" : "" }} {{ item.commodity.specsValue }}</div>
                        <div class="card_price">{{ getPriceType(item.commodity.priceType).symbol }}{{ item.commodity.price}}</div>
                        <div class="card_tools">
                            <van-stepper :min="1" :max="10000" integer input-width="50px" v-model="item.quantity" @change="changeNumber(item)" />
                            <van-icon size="14px" name="delete" @click="deleteItem(item)" v-if="!isDirectOrder" />
                            <div class="clearb"></div>
                        </div>
                    </div>
                    <div class="clearb"></div>
                </div>
                <div class="clearb"></div>
            </div>
            <div class="card_empty" v-if="!items || items.length <= 0">暂无数据...</div>
            <van-cell-group class="card_selectall" v-if="items && items.length > 0 && !isDirectOrder">
                <van-cell>
                    <van-checkbox v-model="selectedAll" checked-color="#f21c0d" @click="selectAllHandle">全选</van-checkbox>
                    <span @click="clearCart()" class="card_clear">清空购物车</span>
                </van-cell>
            </van-cell-group>
            <van-cell-group>
                <van-cell :title="'商品合计：' + getPriceType(priceType).symbol + commodityAmount">
                    订单估重 {{ orderWeight }}kg
                </van-cell>
            </van-cell-group>

            <van-cell-group class="pickut" v-if="!priceType">
                <van-cell title="可用券"></van-cell>
                <van-cell class="cashtitle" v-if="myInfos.cash && myInfos.cash > 0">
                    <span slot="title">
                        可用<span class="red">${{myInfos.cash}}</span>现金券
                    </span>
                    使用$ <input type="number" class="cashcount" maxlength="5" v-model="cashAmount" @blur="ComputeFreight(true)" placeholder="现金券" />
                </van-cell>
                <van-cell class="couponstitle" title="优惠券" @click="isShowCoupons=true" is-link>
                    <span v-if="!couponsItem.amount || couponsItem.amount <= 0">点击选择优惠券</span>
                    <span class="red" v-else>${{couponsItem.amount}}</span>
                </van-cell>
            </van-cell-group>

            <van-cell-group class="pickut">
                <van-cell title="取货方式" />
                <div class="item rowflex" @click="choiseReceivingWay(null)">
                    <i :class="{'iconfont':true,'icon-xuanze':true, 'active':createOrderModel.tenantId === null}"></i>
                    <div class="site">
                        <span>澳洲直邮</span><br/>运费：{{ getPriceType(priceType).symbol }}{{freight}}
                    </div>
                </div>
                <template v-for="item in shops">
                <div class="item rowflex" v-if="item.showOnHome" :key="item.id" @click="choiseReceivingWay(item)">
                    <i :class="{'iconfont':true,'icon-xuanze':true, 'active':createOrderModel.tenantId === item.id}"></i>
                    <div class="site">
                        <span>自提（{{item.name}}）</span><br/>{{item.address.detail}} (电话：{{item.tel}})
                    </div>
                </div>
                </template>
                <div v-if="orderAmountJson && orderAmountJson.takePhotoAmount && !priceType">
                    <van-cell title="其他费用" />
                    <div class="item rowflex" @click="choiseServiceFee()">
                        <i :class="{'iconfont':true,'icon-xuanze':true, 'active':needTakePhoto}"></i>
                        <div class="site">
                            <span>标记拍照服务费：${{orderAmountJson && orderAmountJson.takePhotoAmount}}澳币</span><br/>(${{orderAmountJson && orderAmountJson.takePhotoPrice}}/箱 * {{orderAmountJson && orderAmountJson.parcelCount}}箱)
                        </div>
                    </div>
                </div>
            </van-cell-group>
            <van-cell-group class="card_bottoms">
                <van-cell is-link @click="showPopup(1)" v-if="!createOrderModel.tenantId">
                    <span class="location-icon location-shou">收</span>
                    <dl class="location-infos" v-if="recipients.addressInfo.id && recipients.addressInfo.id > 0">
                        <dt>{{ recipients.addressInfo.addressee.name }} {{ recipients.addressInfo.addressee.tel }}</dt>
                        <dd>{{ recipients.addressInfo.addressee.detail }}</dd>
                    </dl>
                    <span class="location-text" v-if="!recipients.addressInfo.id || recipients.addressInfo.id <= 0">选择收件人</span>
                </van-cell>
                <van-cell is-link @click="showPopup(2)">
                    <span class="location-icon location-ji">寄</span>
                    <dl class="location-infos" v-if="senders.name || senders.tel">
                        <dt>{{senders.name}}</dt>
                        <dd>{{senders.tel}}</dd>
                    </dl>
                    <span class="location-text" v-if="!senders.name && !senders.tel">更新寄件人</span>
                </van-cell>
                <van-cell is-link @click="showPopup(3)">
                    <span class="location-icon location-zhu">注</span>
                    <dl class="location-infos" v-if="remarks.content">
                        <dd>{{remarks.content}}</dd>
                    </dl>
                    <span class="location-text" v-if="!remarks.content">给卖家留言</span>
                </van-cell>
            </van-cell-group>
            <div style="height:115px;"></div>
            <van-submit-bar
                
                :disabled="!selections.length"
                :button-text="submitBarText"
                label="待付："
                :currency="getPriceType(priceType).symbol"
                @submit="onSubmit"
            >
                <!--:price="parseFloat(paymentAmount) * 100"-->
                <div class="order_result"><span class="amount">待付：{{ getPriceType(priceType).symbol }} {{parseFloat(paymentAmount)}}{{ getPriceType(priceType).unit }}</span><template v-if="!priceType"><br /><span class="rmb">(人民币约：{{paymentAmountRMB}}元)</span></template></div>
            </van-submit-bar>

            <cpnpeceiptor :isChoiseReceiptor="receiptorDialogVisible"
                          v-on:choisedReceiptor="choiseReceiptor" v-on:closeRecPopup="closeRecPopup"></cpnpeceiptor>

            <van-popup class="recipients" v-model="isShowPopup" position="right">
                <div v-if="senders.isShowSenders">
                    <van-nav-bar title="更新寄件人" />
                    <div style="height: 50px;"></div>
                    <van-cell-group>
                        <van-field
                            v-model="senders.name"
                            label="姓名" clearable
                            placeholder="请输入寄件人姓名"
                        />
                        <van-field
                            v-model="senders.tel"
                            label="电话" clearable
                            placeholder="请输入联系电话"
                        />
                        <div class="recipients_buttons">
                            <van-button type="primary" size="large" @click="onSaveSender()">保存</van-button>
                            <van-button size="large" @click="onCancelRec()">取消</van-button>
                        </div>
                    </van-cell-group>
                </div>
                <div v-if="remarks.isShowRemarks">
                    <van-nav-bar title="给卖家留言" />
                    <div style="height: 50px;"></div>
                    <van-cell-group>
                        <van-panel>
                            <van-cell title="订单备注" />
                            <van-field
                                v-model="remarks.content"
                                type="textarea"
                                placeholder="请输入订单备注"
                                rows="5"
                                autosize
                                clearable
                            />
                        </van-panel>
                        <div class="recipients_buttons">
                            <van-button type="primary" size="large" @click="onSaveRemark()">保存</van-button>
                            <van-button size="large" @click="onCancelRemark()">取消</van-button>
                        </div>
                    </van-cell-group>
                </div>
            </van-popup>
            <van-popup class="recipients" v-model="isShowCoupons" position="bottom">
                <van-nav-bar title="我的优惠券"
                    left-text="关闭"
                    left-arrow
                    @click-left="isShowCoupons= false"
                />
                <div class="recipients_coupons">
                    <mycoupons :randomVal="Math.random()" v-on:immediateUse="immediateUse"></mycoupons>
                </div>
                <div class="coupons_btn">
                    <van-button type="default" size="large" @click="cancelCoupons">取消使用优惠券</van-button>
                </div>
            </van-popup>
            <!--币种分类-->
            <div class="money_type">
                <template v-for="item in priceTypes">
                    <van-button type="info" :key="item.type" :plain="item.type !== priceType" @click="changePriceType(item.type)">{{ item.value }}商品</van-button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import shopCart from '@/js/mixins/shopCart.js'
    import areaData from '@/js/area.js'
    //import pinYin from 'pinyin-match'
    import cpnpeceiptor from '@/views/m/components/receiptor.vue'
    import mycoupons from '@/views/m/components/myCoupons.vue'
    import { Checkbox, CheckboxGroup, Card, SubmitBar, Stepper, AddressEdit, AddressList, ContactEdit, Tab, Tabs, Panel, Switch } from 'vant'

    export default {
        components: {
            cpnpeceiptor,
            mycoupons,
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [SubmitBar.name]: SubmitBar,
            [CheckboxGroup.name]: CheckboxGroup,
            [Stepper.name]: Stepper,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [ContactEdit.name]: ContactEdit,
            [Panel.name]: Panel,
            [Switch.name]: Switch
        },
        mixins: [shopCart],
        data () {
            return {
                validate: window.consts.validate,
                title: "购物车",
                shops: [], // 门店列表
                items: [], // 购物车的结构 [{id: id, num: num }]
                isDirectOrder: false, //是否直接下单，直接下单不管购物车里面的产品
                freight: 0, //运费
                selections: [], //被选中的产品，如果是点击直接购买进来的，默认就选中
                selectedAll: false,
                areaDataList: [],
                keywords: "",   //搜索收件人信息
                isShowPopup: false, //是否显示弹出
                recipients: {
                    tagActive: 0,
                    filter: {
                        keywords:'',
                        page: 1,
                        size: 1000
                    },
                    addressInfo: {
                        /*"memberId": 0,
                        "id": 0,
                        "name": "",
                        "tel": "",
                        "province": "",
                        "city": "",
                        "area": "",
                        "addressDetail": "",
                        "idCardNo": "",
                        "idCardFrontImageUrl": "",
                        "idCardBackImageUrl": "",
                        "selectAreas": []*/
                    },
                    list: [],
                    selectIndex: null,
                    selectId: null,
                    selectDetail: "",
                    selectName: "",
                    selectTel: ""
                },
                senders: {
                    isShowSenders: false, //是否显示寄件人信息
                    name: "",
                    tel: ""
                },
                remarks: {
                    isShowRemarks: false,
                    content: ""
                },
                createOrderModel: {
                    'orderType': 1, //线上订单
                    "memberId": 0,
                    'tenantId': null, // 自提门店
                    'cashAmount': 0, // 积分抵扣金额
                    'couponId': 0, // 使用的优惠券ID
                    'needTakePhoto': false, // 是否需要签字服务
                    'remark': '',
                    "consignor": {
                        "name": "",
                        "tel": ""
                    },
                    'addressee': { // 收件人
                        "name": '',
                        "tel": '',
                        "province": '',
                        "city": '',
                        "area": '',
                        "detail": '',
                        "idCardNo": '',
                        "idCardFrontImageUrl": '',
                        "idCardBackImageUrl": ""
                    },
                    'items': [
                        /*{
                            "commodityId": 0,
                            "quantity": 0
                        }*/
                    ]
                },
                receiptorDialogVisible: false, //联系人
                isShowCoupons: false, //是否显示优惠券
                cashAmount: "",  //输入的现金券
                couponsItem: {}, //选中的优惠券
                myInfos: {},
                orderWeight: 0.00,  // 订单估重
                commodityAmount: 0.00, // 商品合计
                paymentAmount: 0.00, // 应付金额
                paymentAmountRMB: 0.00, // 应付人民币
                needTakePhoto: false, // 是否选择拍照服务
                orderAmountJson: {}, // 计算订单价格返回的json数据
                appConfig: {}, // 获取配置信息
                priceType: 0
            }
        },
        async mounted() {
            //var dd = pinYin.match("我诶的额斯洛克", "d")
            //console.log(dd)
            await areaData.getAreasData().then(() => {
                this.areaDataList = areaData.getVantArea()
            })
            this.showH5Loading();
            this.getAppSetting();
            this.getShopCartLit();
            this.getShops();
            this.getMyInfo();
        },
        watch: {
            /*selectedAll (v) {
                if (v) {
                    this.selections = this.items
                } else {
                    this.selections = []
                }
            }*/
            selections: {
                deep: true,
                handler: function (newVal, oldVal) {
                    //console.log('filter change')
                    this.ComputeFreight()
                }
            },
            cashAmount() {
                if (!this.cashAmount || this.cashAmount <= 0) {
                    this.cashAmount = "";
                } else if (this.cashAmount >= this.myInfos.cash) {
                    this.cashAmount = this.myInfos.cash;
                }
            },
            '$route'(){
                location.reload();
            }
        },
        computed: {
            submitBarText () {
                const count = this.selections.length
                return '结算' + (count ? `(${count})` : '')
            },
            totalData () {
                let _totalData = {
                    price: 0,
                    weight: 0,
                }
                if (this.selections.length > 0) {
                    let arr = this.selections.map(x => {
                        return x.commodity.price * x.quantity
                    }) //产品的小计集合
                    var total = arr.reduce(function (num, item, index) {
                        return num + item
                    })
                    //计算优惠券和现金券
                    let cash = this.cashAmount || 0;
                    let coupons = this.couponsItem.amount || 0;
                    total = total + parseFloat(this.freight) - cash - coupons;
                    total = total <= 0 ? 0 : total;

                    _totalData.price = this.toFixed(total)
                    //重量计算
                    let arrWeight = this.selections.map(x => {
                        return x.commodity.weight * x.quantity
                    }) //产品的小计集合
                    var totalWeight = arrWeight.reduce(function (num, item, index) {
                        return num + item
                    })
                    _totalData.weight = this.toFixed(totalWeight)
                }
                return _totalData
            }
        },
        methods: {
            getAppSetting() {
                this.axios.get(window.consts.apis.getAppSetting).then(res=>{
                    if(res.success && res.result){
                        this.appConfig = res.result
                    }
                })
            },
            ComputeFreight (isUnLoading) {
                this.freight = 0
                this.orderWeight = 0.00
                this.commodityAmount = 0.00
                this.paymentAmount = 0.00
                this.paymentAmountRMB = 0.00
                if (this.selections.length === 0) {
                    this.orderAmountJson = {}
                    this.freight = 0
                    this.orderWeight = 0.00
                    this.commodityAmount = 0.00
                    this.paymentAmount = 0.00
                    this.paymentAmountRMB = 0.00
                } else {
                    let items = this.selections.map(x => {
                        return {
                            'commodityId': x.commodityId,
                            'quantity': x.quantity
                        }
                    })
                    if (!isUnLoading) {
                        this.showH5Loading();
                    }
                    let isSelfGet = this.createOrderModel && this.createOrderModel.tenantId && this.createOrderModel.tenantId > 0
                    this.$axios.post(window.consts.apis.computeAmount, {
                        "commodities": items,
                        "cashAmount": this.cashAmount || 0,
                        "couponId": this.couponsItem.id || null,
                        "isSelfGet": isSelfGet || false,
                        "needTakePhoto": this.needTakePhoto || false
                    }).then(r => {
                        this.hideH5Loading();
                        if (r.success) {
                            this.orderAmountJson = r.result // 计算的订单价格返回结果
                            this.freight = r.result.freight // 运费
                            this.orderWeight = r.result.weight  // 重量
                            this.commodityAmount = r.result.commodityAmount  // 商品合计
                            this.paymentAmount = r.result.paymentAmount  // 应付金额
                            this.paymentAmountRMB = this.toFixed(r.result.paymentAmount * (this.appConfig && this.appConfig.exchangeRate)) // 人民币
                        } else {
                            this.$toast.fail(r.error.message)
                        }
                    }).catch(e => {
                        this.hideH5Loading();
                    });
                }
            },
            getMyInfo() {
                this.$axios.get(window.consts.apis.getMyInfo).then(res => {
                    this.hideH5Loading();
                    if (res.success) {
                        this.myInfos = res.result;
                        this.senders.name = res.result.consignor.name;
                        this.senders.tel = res.result.consignor.tel;
                    }
                }).catch(e => {
                    this.hideH5Loading();
                });
            },
            getShopCartLit() {
                let that = this;
                //优先处理直接购买--------------------地址栏传参的情况
                let q = this.$route.query
                if (q && q.id) {
                    this.title = "直接下单";
                    this.isDirectOrder = true
                    let _num = q.num > 0 ? q.num : 1;
                    this.axios.get(window.consts.apis.product + '?id=' + q.id).then(res => {
                        this.hideH5Loading();
                        if (res.success) {
                            this.product = res.result
                            this.items = [
                                {
                                    commodity: res.result,
                                    commodityId: q.id,
                                    quantity: _num,
                                }
                            ]
                            this.selectedAll = true
                            this.selections = JSON.parse(JSON.stringify(this.items)) // 点击直接购买进来的，默认就选中
                            // 改变当前币种状态
                            this.priceType = res.result.priceType
                        } else {
                            this.$toast.fail(res.error.message)
                        }
                    }).catch(res => {
                        this.hideH5Loading();
                    })
                }
                //非直接购买再读取购物车数据
                else {
                    this.isDirectOrder = false
                    this.$axios.get(window.consts.apis.getShoppingCartList, { params: { Page: 1, Size: 100} }).then(res => {
                        this.hideH5Loading();
                        if (res.success) {
                            // this.items = res.result.items;
                            this.syncShopCart(res.result.items, function() {
                                that.getShopCartListReload();
                            });
                        } else {
                            this.$toast.fail("加载购物车失败!")
                        }
                    }).catch(e => {
                        this.hideH5Loading()
                        this.$toast.fail("加载购物车失败!")
                    })
                }
            },
            getShopCartListReload() {
                this.$axios.get(window.consts.apis.getShoppingCartList, { params: { Page: 1, Size: 100} }).then(res => {
                    this.hideH5Loading();
                    if (res.success) {
                        this.items = res.result.items.filter(x => {
                            return x.commodity.priceType === this.priceType
                        })
                    }
                })
            },
            // 获取门店列表
            getShops () {
                this.$axios.get(window.consts.apis.shopList + '?page=1&size=1000').then(res => {
                    this.hideH5Loading();
                    if (res.success) {
                        this.shops = res.result.items
                    }
                }).catch(e => {
                    this.hideH5Loading();
                })
            },
            // 选择提货方式
            choiseReceivingWay (store) {
                if (store) {
                    this.createOrderModel.tenantId = store.id
                } else {
                    this.createOrderModel.tenantId = null
                }
                this.ComputeFreight()
            },
            // 选择拍照服务
            choiseServiceFee() {
                this.needTakePhoto = !this.needTakePhoto
                if (this.needTakePhoto) {
                    this.showPopup(3)
                }
                this.ComputeFreight()
            },
            selectAllHandle () {
                if (this.isDirectOrder) {
                    this.$toast.fail('直接下单的商品不能取消选择')
                    return false
                } else {
                    this.selectedAll = !this.selectedAll
                    if (this.selectedAll) {
                        this.selections = JSON.parse(JSON.stringify(this.items))
                    } else {
                        this.selections = []
                    }
                    console.log(this.selections)
                }
            },
            changeSelectState (item) {
                if (this.isDirectOrder) {
                    this.$toast.fail('直接下单的商品不能取消选择')
                    return false
                } else {
                    //console.log(this.selections.map(x=>x.commodityId).join(','))
                    if (this.selections.filter(x => x.commodityId === item.commodityId).length === 0) {
                        this.selections.push(item)
                    } else {
                        //移除
                        let index = this.selections.findIndex((element) => (element.commodityId === item.commodityId))
                        this.selections.splice(index, 1)
                        //console.log('index',index)
                    }
                    //console.log('===========',this.selections.map(x=>x.commodityId).join(','))
                }
                // 实现选中全选
                if (this.selections.length <= 0) {
                    this.selectedAll = false
                } else if (this.selections.length === this.items.length) {
                    this.selectedAll = true
                }
            },
            //修改购物车数量
            changeNumber (item, isDelete) {
                if (this.isDirectOrder === false) {
                    if (isDelete) {
                        this.$dialog.confirm({
                            message: "确定要删除购物车数据吗？"
                        }).then(r => {
                            this._editCart({ commodityId: item.commodityId, quantity: item.quantity }).then(res => {
                                if (res.success) {
                                    if (this.deleteShopCartLocalStorage(item)) {
                                        this.getShopCartListReload();
                                        //this.ComputeFreight()
                                    }
                                } else {
                                    this.$toast.fail(res.error.message);
                                }
                            }).catch(e => {
                                this.$toast.fail(e);
                            })
                            for (let i = 0; i < this.selections.length; i++) {
                                if (this.selections[i].commodityId === item.commodityId) {
                                    this.selections[i].quantity = item.quantity;
                                }
                            }
                        })
                    } else {
                        this._editCart({ commodityId: item.commodityId, quantity: item.quantity }).then(res => {
                            if (res.success) {
                                this.setShopCartLocalStorage(item, 1);
                            } else {
                                this.$toast.fail(res.error.message);
                            }
                        }).catch(e => {
                            this.$toast.fail(e);
                        })
                        for (let i = 0; i < this.selections.length; i++) {
                            if (this.selections[i].commodityId === item.commodityId) {
                                this.selections[i].quantity = item.quantity;
                            }
                        }
                    }
                } else {
                    for (let i = 0; i < this.selections.length; i++) {
                        if (this.selections[i].commodityId === item.commodityId) {
                            this.selections[i].quantity = item.quantity
                        }
                    }
                }
            },
            deleteItem(item) {
                if (!item || !item.commodity || isNaN(item.commodity.id) || item.commodity.id <= 0) {
                    return false;
                }
                let temp = {
                    commodityId: item.commodity.id,
                    quantity: 0
                };
                this.changeNumber(temp, true);
            },
            clearCart() {
                this.$dialog.confirm({
                    message: "确定要清空购物车吗？"
                }).then(r => {
                    this.$axios.post(window.consts.apis.clearShopCart).then(res => {
                        if (res.success) {
                            this.commodityAmount = 0.00
                            this.paymentAmount = 0.00
                            this.paymentAmountRMB = 0.00
                            this.clearShopCartLocalStorage(() => {
                                location.reload()
                            });
                            this.getShopCartListReload();
                            //this.ComputeFreight()
                        }
                    })
                })
            },
            onSubmit () {
                var that = this;
                if (!this.selections || this.selections.length <= 0) {
                    this.$toast.fail("请选择需要结算的产品!");
                    return false;
                } else if ((!this.recipients.addressInfo.id || this.recipients.addressInfo.id <= 0) && (!this.createOrderModel.tenantId || this.createOrderModel.tenantId <= 0)) {
                    this.$toast.fail("请选择收件人!");
                    return false;
                } else if (!this.senders.name || !this.senders.tel) {
                    this.$toast.fail("请选择填写寄件人!");
                    return false;
                } else {
                    this.createOrderModel.memberId = this.myInfos.id;
                    this.createOrderModel.cashAmount = parseInt(this.cashAmount) || 0;
                    this.createOrderModel.couponId = this.couponsItem.id || null;
                    this.createOrderModel.needTakePhoto = this.needTakePhoto
                    this.createOrderModel.remark = this.remarks.content;
                    this.createOrderModel.consignor.name = this.senders.name;
                    this.createOrderModel.consignor.tel = this.senders.tel;
                    if (!this.createOrderModel.tenantId || this.createOrderModel.tenantId <= 0) {
                        for (var i in this.createOrderModel.addressee) {
                            this.createOrderModel.addressee[i] = this.recipients.addressInfo.addressee[i];
                        }
                    } else {
                        this.createOrderModel.addressee = null
                    }
                    //this.createOrderModel.addressee = this.recipients.addressInfo.addressee;
                    this.createOrderModel.items = this.selections;
                    //console.log(this.createOrderModel);
                    this.showH5Loading();
                    this.$axios.post(window.consts.apis.createOrder, this.createOrderModel).then(res => {
                        this.hideH5Loading();
                        if (res.success) {
                            this.$toast.success({
                                duration: 2000,
                                forbidClick: true,
                                loadingType: 'spinner',
                                message: "订单提交成功!",
                                onClose: (rt => {
                                    if (this.isDirectOrder) {
                                        this.$router.push({ path: '/m/payment/' + res.result.id })
                                    } else {
                                        this.deleteShopCartLocalStorageArray(this.createOrderModel.items, function(){
                                            that.$router.push({ path: '/m/payment/' + res.result.id })
                                        });
                                    }
                                })
                            });
                        } else {
                            this.$dialog.alert({ message: res.error.message });
                            return false;
                        }
                    }).catch(e => {
                        this.hideH5Loading();
                    });
                }
            },
            //打开底部收件人，寄件人，备注
            showPopup(index) {
                switch(index) {
                    case 1: 
                        this.receiptorDialogVisible = true
                        this.senders.isShowSenders = false
                        this.remarks.isShowRemarks = false
                        this.isShowPopup = false
                        break;
                    case 2: 
                        this.closeRecPopup(false)
                        this.senders.isShowSenders = true
                        this.remarks.isShowRemarks = false
                        this.isShowPopup = true
                        break;
                    case 3:
                        this.closeRecPopup(false)
                        this.senders.isShowSenders = false
                        this.remarks.isShowRemarks = true
                        this.isShowPopup = true
                        break;
                }
            },
            onCancelRec(isRec) {
                this.isShowPopup = false
            },
            onCancelRemark() {
                this.remarks.content = "";
                this.isShowPopup = false;
            },
            onSaveSender() {
                if (!this.senders.name) {
                    this.$toast.fail("寄件人姓名必填!");
                    return false;
                } else if (!this.senders.tel) {
                    this.$toast.fail("电话号码格式错误!");
                    return false;
                }
                this.senders.isShowSenders = false;
                this.onCancelRec();
            },
            onSaveRemark() {
                this.remarks.isShowRemarks = false;
                this.onCancelRec();
            },
            choiseReceiptor(item) {
                this.recipients.addressInfo = item;
                this.closeRecPopup(false);
                return false;
                for (var i in this.orderDetail.addressee) {
                    this.orderDetail.addressee[i] = item.addressee[i];
                }
                this.orderDetail.addressee.detailAddress = item.addressee.fullAddress;
                this.closeRecPopup(false);
            },
            closeRecPopup(data) {
                this.receiptorDialogVisible = data;
            },
            cancelCoupons() {
                this.couponsItem = {};
                this.isShowCoupons = false;
                this.ComputeFreight(true);
            },
            immediateUse(data) {
                this.couponsItem = data;
                this.ComputeFreight()
                this.isShowCoupons = false;
            },
            changePriceType(type) {
                // 设置币种
                this.priceType = type
                // 更新购物车显示数据
                this.getShopCartListReload()
                // 取消全选，因此默认设为已经全选
                this.selectedAll = true
                this.selectAllHandle()
                // 重置优惠券
                this.cashAmount = ""
                this.cancelCoupons()
                // 重置拍照服务费
                this.needTakePhoto = true
                this.choiseServiceFee()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-goods {
        .van-cell {
            padding:10px;
        }
        padding: 10px 0;
        background-color: #fff;

        &__item {
            position: relative;
            padding: 0 8px;
            background-color: #fff;
            border-bottom: 1px solid #efefef;
            .van-checkbox__icon {
                top: 50%;
                left: 10px;
                z-index: 1;
                position: absolute;
                margin-top: -10px;
            }

            .van-card__price {
                color: #f44;
            }
        }
        ::v-deep &__item .van-checkbox__label {
            width: calc(100% - 30px);
            height: auto;
            padding: 0;
            box-sizing: border-box;
            .van-card {
                padding: 10px 5px;
                background: #fff;
            }
        }
    }
    .card {
        &_item {
            float: right;
            font-size: 12px;
            
            -webkit-box-flex: 1;
            flex: 1;
        }
        &_left {
            float: left;
            width:80px;
            height: auto;
            img {
                width:100%;
                height:100%;
            }
        }
        &_right {
            float: right;
            width: calc(100% - 90px);
            .van-stepper {
                float:left;
            }
            .van-icon {
                float: right;
                margin-top:8px;
                text-align: right;
            }
        }
        &_title {
            line-height: 1.3;
            font-size: 14px;
            font-weight: bold;
            color: #1a1a1a;
        }
        &_desc {
            color: #999;
            line-height: 1.6;
        }
        &_price {
            color: #f21c0d;
            font-size: 16px;
            font-weight: bold;
        }
        &_checked_label {
            position: relative;
            display: inline-block;
            width: 22px;
            height: 22px;
            border:1px solid #ccc;
            border-radius: 22px;
        }
        &_checked_label.active {
            border-color: #2c8f7b;
            background:#2c8f7b;
        }
        &_checked_label.active::after {
            content: "";
            position: absolute;
            left: 4px;
            top: 6px;
            width: 50%;
            height: 25%;
            border: 3px solid #fff;
            border-radius: 1px;
            border-top: none;
            border-right: none;
            background: #2c8f7b;
            transform: rotate(-45deg);
        }
        &_checked {
            display: none;
        }
        &_row {
            padding: 10px;
            border-bottom: 1px solid #efefef;
            background:#fff;
            i {
                display: inline-block;
                width: 30px; 
                height:30px;
                line-height: 30px;
                font-size: 20px;
                color: #aaa;
            }
            i.active {
                color: #f21c0d;
            }
        }
        &_tools {
            margin-top:6px;
        }
        &_bottoms {
            margin-top:10px;
            .location-icon {
                display:inline-block;
                width:38px; 
                height:38px;
                line-height: 38px;
                font-size: 22px;
                font-weight: bold;
                text-align: center;
                border-radius:38px;
                color: #fff;
            }
            .location-shou {
                background:#40c58a;
            }
            .location-ji {
                background:#9d9dff;
            }
            .location-zheng {
                background:#f67bc6;
            }
            .location-zhu {
                background:#e91e63;
            }
            .location-text {
                float:right;
                line-height: 38px;
                color: #aaa;
            }
            .location-infos {
                float:right;
                width: calc(100% - 50px);
                text-align: left;
                margin: -1px 0 -2px;
                dt {
                    font-size: 16px;
                    color: #000;
                    font-weight: bold;
                }
                dd {
                    color: #999;
                    margin:0;
                }
            }
            .van-cell__right-icon {
                margin-top:8px;
            }
        }
        &_selectall {
            .van-checkbox {
                float: left;
            }
            .card_clear {
                float: right;
                color: #969799;
            }
        }
        &_empty {
            text-align: center;
            height: 80px;
            line-height: 80px;
            background: #fff;
        }
    }

    .van-nav-bar {
        background: #387ef5;
        box-sizing: border-box;
    }

    .van-nav-bar__title {
        color: #ffffff;
    }

    .van-submit-bar {
        bottom: 60px;
        background:#01579b;
        .van-submit-bar__text {
            span {
                color:#fff;
                font-size: 16px;
            }
        }
    }
    .pickut {
        margin-top:10px;
        .item {
            padding: 10px;
            font-size: 16px;
            border-bottom: 1px dashed #efefef;
            i {
                display:inline-block;
                width: 30px;
                height:30px;
                line-height: 30px;
                font-size: 20px;
                color: #aaa;
            }
            i.active {
                color: #f21c0d;
            }
            .site {
                -webkit-box-flex: 1;
                flex: 1;
            }
        }
        .cashtitle {
            .red {
                color: #f21c0d;
                font-size: 1.4rem;
                margin: 0 5px;
            }
            .cashcount {
                width: 62px;
                height: 26px;
                line-height: 26px;
                text-indent: 6px;
                border: 1px solid #eee;
                border-radius: 4px;
                color: #f21c0d;
            }
        }
        .couponstitle {
            .red {
                color: #f21c0d;
            }
        }
    }
    .rowflex{
        display: flex;
        flex-direction: row;
    }
    /* 收件人 */
    .recipients {
        width:100%;
        height:100%;
        background:#fff;
        &_group {
             margin-top:5px;
        }
        &_address {
            margin:-1px 0 -2px;
            dt {
                font-size: 16px;
                color: #000;
                font-weight: bold;
            }
            dd {
                color: #999;
                margin:0;
            }
        }
        &_buttons {
            padding: 15px;
            .van-button {
                margin-top:10px;
            }
        }
        &_upload_box {
            padding:0 15px 15px;
            .title {
                display: inline-block;
                padding: 6px 0;
            }
            .uploads {
                margin: 5px auto;
                width:100%;
                height:auto;
                min-height:100px;
                border:1px dashed #dddddd;
            }
            .uploads span {
                display: block;
                width:100%;
                height: 100%;
                text-align: center;
                i {
                    display: inline-block;
                    width:100%;
                    height:100px;
                    line-height: 100px;
                    font-style: normal;
                    color: #999;
                }
                img {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
            }
        }
        &_coupons {
            margin-top: 48px;
            height: calc(100% - 110px);
            overflow: auto;
        }
        .coupons_btn {
            position: fixed;
            left: 1%;
            bottom: 10px;
            width: 98%;
        }
        .van-nav-bar__text {
            color: #fff;
        }
    }
    .order_result {
        text-indent: 12px;
        .amount {
            color: #fff;
            font-size: 16px;
        }
        .rmb {
            color: #eee;
            font-size: 13px;
            margin-left: 10px;
        }
    }
    .money_type {
        position: fixed;
        top: 50px;
        width: 100%;
        .van-button {
            float: left;
            margin: 0 1%;
            width: 48%;
            height: 28px;
            border-radius: 3px;
            line-height: 28px;
            text-align: center;
        }
        .van-button--info {
            background: #1c82d4;
        }
        .van-button--plain {
            background: #fff;
        }
    }
    .cmain {
        padding-top: 40px;
    }
</style>
